import asyncComponent from '../../components/AsyncComponent';

const AsyncWorkflowPlayer = asyncComponent(() => import('../../containers/Workflow/Player'));

export default AsyncWorkflowPlayer;
